// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast } from 'vant';
import md5 from 'js-md5';
import { Dialog } from 'vant'
import $ from 'jquery'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// import VConsole from 'vconsole'
//  引入Echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// new VConsole();

Vue.use(Viewer)

// 全局注册
Vue.use(Dialog);

Vue.prototype.$md5 = md5;

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Toast);
// 路由权限
import Watermark from './assets/js/waterMark';
router.beforeEach((to, from, next) => {
    var token = localStorage.getItem("token");
    // console.log(token)
    if (!token && to.path !== '/login' && to.path !== '/forget' && to.path !== '/resetPsw') {
        Toast.fail('登录失败,请重新登录');
        next({
            path: '/login',
        })
    }
    next()
})
router.afterEach((to) => {
    if (JSON.parse(localStorage.getItem('userInfo')) != null) {
        let userName = JSON.parse(localStorage.getItem('userInfo')).userName
        Watermark.set(userName);
    }
});
window.addEventListener('popstate', function() {
    history.pushState(null, null, document.URL)
})
let startX, startY;
document.body.addEventListener("touchstart", function(e) {
    startX = e.touches[0].pageX;
    startY = e.touches[0].pageY;
});
document.body.addEventListener("touchmove", function(e) {
    var moveX = e.touches[0].pageX;
    var moveY = e.touches[0].pageY;
    if (Math.abs(moveX - startX) > Math.abs(moveY - startY)) {
        e.preventDefault();
    }
}, { passive: false });
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',

})


// WEBPACK FOOTER //
// ./src/main.js